'use strict';

angular.module('app')
  .service('Auth', function ($location, $rootScope, $injector, Request, diviacLocalStorage, GTM, utils) {
    var Auth = {},
      aud = window.location.origin === 'https://travel.padi.com' ? '503u87mvc25i53veank5m32e6i' : '7u0q6o7jbqck26k2adbdu6qbjk',
      sub = utils.getCookie('CognitoIdentityServiceProvider.' + aud + '.LastAuthUser'),
      cognitoCookieName = 'CognitoIdentityServiceProvider.' + aud + '.' + sub,
      refreshTokenCookieName = cognitoCookieName + '.refreshToken',
      idTokenCookieName = cognitoCookieName + '.idToken';

    Auth.isLoggedIn = function () {
      return localStorage.getItem('token');
    };

    Auth.tokenVerify = function () {

    };

    Auth.isStaff = function () {
      var user = diviacLocalStorage.get('user');

      return user ? user.isStaff : false;
    };

    Auth.isAffiliate = function () {
      var user = diviacLocalStorage.get('user');

      return user && user.affiliate ? true : false;
    };

    Auth.getReferralCode = function () {
      return $location.search().coupon_code || null;
    };

    Auth.getPromoCoupon = function () {
      return diviacLocalStorage.get('promo_code') || null;
    };

    Auth.getToken = function () {
      return localStorage.getItem('token');
    };

    Auth.handleError = function (error) {
      if (error.status === 403) {
        return [error.statusText];
      }

      if (error.data) {
        var messages = [];
        _.each(error.data, function (val) {
          messages.push(val[0]);
        });

        return messages;
      }
    };

    Auth.redirectBack = function () {
      return false;
      // if ($rootScope.toState) {
      //   $location.path($rootScope.toState).hash('');
      //   $rootScope.toState = null;

      //   return 1;
      // }

      // $location.path(utils.createURL('bookings')).hash('');
      // if ($rootScope.oldState) {
      //     $window.history.back();
      // } else {
      //     $location.path('/').hash('');
      // }
    };

    Auth.saveToken = function (token) {
      localStorage.setItem('login_date', moment().format('YYYY-MM-DD'));
      localStorage.setItem('token', token);

      return this;
    };

    Auth.saveUser = function (data) {
      if (!data) {
        return this;
      }

      return localStorage.setItem('user', JSON.stringify(data));
    };

    Auth.getUser = function () {
      return localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : false;
    };

    Auth.logout = function () {
      // logout on all our sites;
      Request.post('account/logout/');

      GTM.event('user_login_logout');
      utils.deleteCookie(refreshTokenCookieName);
      utils.deleteCookie(idTokenCookieName);
      $rootScope.user = false;
      localStorage.removeItem('token');
      // $location.path(utils.createURL('login'));
      return localStorage.removeItem('user');
    };

    Auth.checkCookie = function (callback) {
      var _this = this,
        idToken = utils.getCookie(idTokenCookieName);
      if (!idToken) {
        if (typeof callback === 'function') {
          return callback();
        }
        return false;
      }

      return Request.get('account/get-userdata/').then(function (res) {
        res.data.token = idToken;
        if (res.data) {
          $rootScope.user = _this.getUser();
        }
        if (typeof callback === 'function') {
          return callback(res.data);
        }
        return res.data;
      });
    };

    Auth.tokenRefresh = function () {
      const refreshToken = utils.getCookie(refreshTokenCookieName);
      if (!refreshToken) {
        return false;
      }

      return Request.post(window.location.origin === 'https://travel.padi.com'
        ? 'https://api.global-prod.padi.com/auth/api/oauth/refresh'
        : 'https://api-stage.global-np.padi.com/auth/api/oauth/refresh/', {
        clientId: aud,
        refreshToken,
      }).then(function (res) {
        var data = res.data,
          params = {
            expires: data.expiresIn,
            domain: '.' + window.location.hostname.split('.').slice(-2).join('.'),
            path: '/',
          };
        utils.setCookie(idTokenCookieName, data.idToken, params);
      });
    };

    Auth.parseJWT = function (token) {
      var base64Url = token.split('.')[1],
        base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/'),
        jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

      return JSON.parse(jsonPayload);
    };


    Auth.userMeasurements = function () {
      return Request.get('user-measurements/').then(function (res) {
        $rootScope.temperature = res.data.temperature;
        $rootScope.distance = res.data.length;
        $rootScope.currency = utils.getCookie('currency_code') || res.data.currency;
      });
    };

    Auth.checkAffiliate = function () {
      return Request.get('account/affiliate-info/').then(function (res) {
        return res.data;
      });
    };

    Auth.showTermsModal = function (callback) {
      var $uibModal = $injector.get('$uibModal'),
        modalInstance = $uibModal.open({
          animation: true,
          backdrop: 'static',
          keyboard: false,
          templateUrl: '../templates/_activate_account-popup.html',
          controller: function ($rootScope, $uibModalInstance) {
            var vm = this;

            vm.form = {
              isTermsAccepted: false,
              toSubscribe: false,
            };

            vm.activate = function (form) {
              if (form.$invalid) { return false; }

              Auth.confirmTerms(vm.form, true).then(function () {
                $rootScope.user = Auth.getUser();
                $uibModalInstance.close();
              });
            };
          },
          controllerAs: 'termsPopup',
        });

      return modalInstance.result.then(function (res) {
        if (callback) { callback(); }
      }, function (err) {
      });
    };

    return Auth;
  });
